import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

interface Request {
    protocol: string;
    host: string;
    url: string;
    id: string | null;
    xsrfToken: string;
}

export default autoGeneratedReducer<Request>({
    protocol: 'https',
    host: 'hh.ru',
    url: '',
    id: null,
    xsrfToken: '',
});
